import { BufferingIndicator as BufferingIndicator$1 } from "../../../../../ui/buffering-indicator/component.js";
import ForwardRef from "../../../../../icons/dist/react/default/spinner.js";
import { jsx } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/default-live-video/components/feedback/buffering-indicator.tsx
/** @jsxImportSource react */
function BufferingIndicator({ className, ...props } = {}) {
	return /* @__PURE__ */ jsx(BufferingIndicator$1, {
		className: (state) => cn("media-buffering-indicator", resolveClassName(className, state)),
		...props,
		children: /* @__PURE__ */ jsx(ForwardRef, { className: "media-buffering-indicator-spinner-icon" })
	});
}
//#endregion
export { BufferingIndicator };

//# sourceMappingURL=buffering-indicator.js.map